import { defineMessages } from 'react-intl';

export default defineMessages({
  addbiller: {
    id: 'billerCreate',
    defaultMessage: 'Add New Biller',
  },
  addBillerCreateForm: {
    id: 'billerCreate.newForm',
    defaultMessage: 'Create New Form',
  },
  addBillerBreadcrumb: {
    id: 'billerCreate.addBillerBreadcrumb',
    defaultMessage: 'Billers',
  },
  addBillerBreadcrumb2: {
    id: 'billerCreate.addBillerBreadcrumb2',
    defaultMessage: 'Add New',
  },
  addBillerMandatory: {
    id: 'billerCreate.mandatoryField',
    defaultMessage: 'Mandatory Field',
  },
});
